import React from 'react';
import { Container, Form, Button, Card, Row, Col } from 'react-bootstrap';
import { useForm, usePage } from '@inertiajs/react';
import { useLaravelReactI18n } from 'laravel-react-i18n';

function Edit() {
    const { t } = useLaravelReactI18n();
    const { transaction,userNames } = usePage().props;

    const { data, setData, put, post, processing, progress, transform, errors } = useForm(transaction ? {
        type: transaction.type,
        amount: transaction.amount,
        description: transaction.description,
        user_id: transaction.user_id,
        date: transaction.date
    } : {
        type: 'expense',
        amount: '',
        description: '',
        user_id: 1,
        date: new Date().toLocaleDateString('en-CA')
    });

    function handleChange(e) {
        const key = e.target.id;
        const value = e.target.value;
        setData({
            ...data,
            [key]: value,
        });
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (transaction) {
            put('transactions/'+transaction.id, { forceFormData: true });
        } else {
            post(`/transactions`, { forceFormData: true });
        }
    }

    return (
        <Container>
            <Form onSubmit={handleSubmit}>
                <Card>
                    <Card.Header className={"d-flex justify-content-between"}>
                        <h5>{t(transaction ? 'Edit transaction' : 'Create transaction')}</h5>
                        <Button variant="primary" type="submit" disabled={processing}>
                            {t('save')}
                        </Button>
                    </Card.Header>
                    <Card.Body>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>
                                {t('Type')}
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control
                                    as="select"
                                    className={errors.type ? 'is-invalid' : ''}
                                    id="type"
                                    value={data.type}
                                    onChange={handleChange}
                                >
                                    <option value="">{t('Select type')}</option>
                                    <option value="income">{t('income')}</option>
                                    <option value="expense">{t('expense')}</option>
                                    <option value="balancing">{t('balancing')}</option>
                                </Form.Control>
                                {errors.type && <div className="invalid-feedback">{errors.type}</div>}
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>
                                {t('Amount')}
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control
                                    className={errors.amount ? 'is-invalid' : ''}
                                    placeholder={t('Enter amount')}
                                    id="amount"
                                    type="number"
                                    value={data.amount}
                                    onChange={handleChange}
                                />
                                {errors.amount && <div className="invalid-feedback">{errors.amount}</div>}
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>
                                {t('Description')}
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control
                                    className={errors.description ? 'is-invalid' : ''}
                                    placeholder={t('Enter description')}
                                    id="description"
                                    type="text"
                                    value={data.description}
                                    onChange={handleChange}
                                />
                                {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>
                                {t('User')}
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control
                                    as="select"
                                    className={errors.user_id ? 'is-invalid' : ''}
                                    id="user_id"
                                    value={data.user_id}
                                    onChange={handleChange}
                                >
                                    <option value="">{t('Select user')}</option>

                                    {Object.entries(userNames).map((user, index) => (
                                        <option key={index} value={user[0]}>{user[1]}</option>
                                    ))}
                                </Form.Control>
                                {errors.user_id && <div className="invalid-feedback">{errors.user_id}</div>}
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>
                                {t('Date')}
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control
                                    className={errors.date ? 'is-invalid' : ''}
                                    id="date"
                                    type="date"
                                    value={data.date}
                                    onChange={handleChange}
                                />
                                {errors.date && <div className="invalid-feedback">{errors.date}</div>}
                            </Col>
                        </Form.Group>

                    </Card.Body>
                </Card>
            </Form>
        </Container>
    );
}
export default Edit;
